<template>
  <div>
    <div class="lf w326 emergencyEvent ml" id="emergencyTable">

      <div class="inner-wraps">
        <div class="nursing">
          <div class="nursing_item">
            商户排名
          </div>
          <div class="nursing_item">
            商户名称
          </div>
          <div class="nursing_item">
            入驻类型
          </div>
          <div class="nursing_item">
            入驻时间
          </div>
        </div>
        <el-carousel arrow="never" indicator-position="none" interval="4000" height="33.4vh" direction="vertical" :autoplay="true">
          <el-carousel-item v-for="(item,index) in 5" :key="item">
            <div class="nursing" v-for="(ite,idx) in 5">
              <div class="nursing_item">
                {{idx+1}}
              </div>
              <div class="nursing_item">
                官方旗舰店
              </div>
              <div class="nursing_item">
                {{idx%2 == 0?'服务':'商品'}}
              </div>
              <div class="nursing_item">
                2022-07-{{idx+10}}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <title-h3 :titlemsg="titlemsg"></title-h3>
      <!-- <div class="inner-wrap">

        <div class="argument-warp">
            <div class="emergencyTable fl">
              <GeminiScrollbar class="content">
                <div class="clearfix scrolltable">
                  <el-row>
                    <el-table
                      :data="tableData"
                      v-loading.body="loading"
                      border
                      @selection-change="selectionChange"
                      style="width: 100%;">
                      <el-table-column
                        type="selection"
                        style="width: 5.1%">
                      </el-table-column>
                      <el-table-column
                        prop="birth"
                        label="商户名称"
                        style="width: 12.79%">
                      </el-table-column>
                      <el-table-column
                        prop="measures"
                        label="商户类别">
                        自营
                      </el-table-column>
                      <el-table-column
                        prop="province"
                        label="商户姓名"
                        style="width: 15.79%">
                      </el-table-column>
                      <el-table-column
                        prop="city"
                        label="商户地址"
                        style="width: 21.91%">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                        label="创建时间"
                        style="width: 20.74%">
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </GeminiScrollbar>
            </div>
            <div class="emergencyMap fl">
            </div>
        </div>
      </div> -->
    </div>
  </div>

</template>

<script>
  //引入jQuery
  import '../../assets/js/jquery-1.9.1.min.js'
  import title from '../title'
  export default{
    name:'scenicStatistics',
    data(){
      return{
        titlemsg:'最新入驻',
        tableData: [
        {
          birth: '商户名称',
          name: '2018-04-10',
          province: '4235',
          city: '5423',
          measures:'联系管理人员'
        },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '643',
            city: '653',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '65',
            city: '653',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '54',
            city: '54',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '64',
            city: '3',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '65',
            city: '444',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '643',
            city: '63',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '653',
            city: '35',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '653',
            city: '4',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '677',
            city: '634',
            measures:'联系管理人员'
          },
          {
            birth: '商户名称',
            name: '2018-04-10',
            province: '43',
            city: '657',
            measures:'联系管理人员'
          }
        ],
        //显示加载中样式
        loading:false,
        //搜索表单
        searchForm: {
          id: '',
          name: '',
          state: ''
        },
        //多选值
        multipleSelection: [],
        //当前页
        currentPage:3,
        //分页大小
        pageSize:100,
        //总记录数
        total:800,
        //删除的弹出框
        deleteVisible:false,
        //编辑界面是否显示
        editFormVisible: false,
        editLoading: false,
        editFormRules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ]
        },
        //编辑界面数据
        editForm: {
          id: 0,
          name: '',
          sex: -1,
          age: 0,
          birth: '',
          address: ''
        }
      }
    },
    components:{
      'title-h3':title
    },
    methods:{
      selectionChange(){

      }
    }
  }

</script>

<style>
  .emergencyEvent{width: 49.1%;height:4.14rem;}
  /* .emergencyEvent .inner-wrap{height: 3.64rem; width: 100%;border-radius: 4px;padding-top: .08rem;overflow:hidden} */
  .emergencyEvent .argument-warp{width: 98.4%;height: 3.54rem;margin: 0 auto;border-radius: 4px;}
  .w67{width:65.7%}

  .emergencyTable{width: 97%;height: 3rem;border: 1px solid #3b72ee;border-radius: 4px;margin-left: 1%;margin-top:2%;}
  .emergencyMap{width: 48%;height: 100%;margin-left: 1%;}
/*表格样式*/
  #emergencyTable .el-table th, .el-table tr {
    background-color: #012352!important;
    border: 1px solid #1b49a2;
    text-align: center;
    border-bottom:none;
  }
  #emergencyTable .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #002c6a;
  }
  #emergencyTable .el-table--border, .el-table--group {
    border: 1px solid #3b72ee;
  }
  #emergencyTable .el-table thead {
    font-size: 0.12rem;
    color: #fff;
    font-weight: 500;
    background: blue!important;
    text-align: center;
    border-bottom: none;
  }
  #emergencyTable table th {
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.12rem;
    text-align: center;
    border:none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  #emergencyTable .el-table__body, .el-table__footer, .el-table__header {
    border-bottom: none;
  }
  #emergencyTable .el-table th, .el-table tr{background: none;}
  #emergencyTable .el-table td, .el-table th {
    padding:  0;
  }
  #emergencyTable .el-table {
    font-size:  0.12rem;
    color: #81b2ff;
    text-align: center;
  }
  #emergencyTable .el-checkbox__inner {
    border: 1px solid #1b49a2;
    border-radius: 2px;
    width:  0.12rem;
    height:  0.12rem;
    background-color: #0e3883;
  }
  #emergencyTable .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #1b49a2;
  }
  #emergencyTable .el-table--border::after, .el-table--group::after {  width:0}
  #emergencyTable .el-table::before {  height: 0px;  }
  #emergencyTable .el-table td, .el-table th.is-leaf{border-bottom:none}
  #emergencyTable table td{border-left:none;border-top:1px solid #1b49a2;float: none;}
  .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{border-right:none}
  .el-table__body, .el-table__footer, .el-table__header{
    border-collapse:collapse;
  }

  #emergencyTable a{color: #81b2ff;padding: 0.03rem 0.6rem;display: inline-block;}
  .nursing{
    color: #fff;
    display: flex;
  }
  .nursing_item{
    flex: 1;
    text-align: center;
    height: 0.59rem;
    line-height: 0.59rem;
    font-size: 0.15rem;
  }
  .nursing_item:nth-child(5n){
    /* border-right: 1px solid #1e6bb4; */
  }
  .nursing:last-child{
    /* border-bottom: 1px solid #1e6bb4; */
  }
  /deep/.el-carousel__indicators{
    display: none;
  }
  /* height: 1.8rem; height: 3.64rem; */
  .inner-wraps{background-color: #100235;box-sizing: border-box; height:40vh;box-sizing:border-box; width: 100%;border-radius: 4px;overflow:hidden;padding-top: 0}
</style>



// WEBPACK FOOTER //
// src/components/emergencyManage/emergencyEvent.vue